(function () {
  var modal = null;
  var form = null;
  // Set when the Notify Me form itself is submitted. Every customer form (the
  // footer newsletter too) comes back with ?customer_posted=true, so that
  // parameter alone can't tell whose submission it was - without this the
  // "You'll be notified!" toast also showed after a newsletter sign-up.
  var SUBMITTED_KEY = 'aiza:notify-me-submitted';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    modal = document.querySelector('[data-notify-me-modal]');
    if (!modal) return;

    form = modal.querySelector('.notify-me-modal-form');

    document.querySelectorAll('[data-notify-me-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('[data-form-wrapper]');
        var variantInput = wrapper && wrapper.querySelector('[data-product-select]');
        openNotifyMeModal(variantInput ? variantInput.value : '');
      });
    });

    setupClose();
    setupPhoneValidation();
    setupMarketingToggle();

    if (form) {
      form.addEventListener('submit', buildPhoneValue);
      form.addEventListener('submit', updateTags);
      form.addEventListener('submit', function () {
        try {
          sessionStorage.setItem(SUBMITTED_KEY, '1');
        } catch (e) {}
      });
    }

    checkForToast();
  }

  function openNotifyMeModal(variantId) {
    if (!modal) return;

    var variantInput = modal.querySelector('[data-notify-variant-input]');
    if (variantInput) variantInput.value = variantId ? 'notify_variant_' + variantId : '';

    updateTags();

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      modal.classList.add('show');
    });
  }

  function closeNotifyMeModal() {
    if (!modal) return;
    document.body.style.overflow = '';
    modal.classList.remove('show');
    setTimeout(function () {
      modal.style.display = 'none';
    }, 300);
  }

  function updateTags() {
    if (!form) return;
    var tagsInput = form.querySelector('[data-notify-tags-input]');
    if (!tagsInput) return;

    var tags = [];

    var variantInput = form.querySelector('[data-notify-variant-input]');
    if (variantInput && variantInput.value) tags.push(variantInput.value);

    tags.push('action_notifyStock');
    tags.push('notify_ts_' + Math.floor(Date.now() / 1000));
    tags.push(modal.dataset.notifyLangTag || 'notify_lang_en');

    var phoneValueInput = form.querySelector('[data-notify-phone-value]');
    if (phoneValueInput && phoneValueInput.value) tags.push('phone_' + phoneValueInput.value);

    var marketingCheckbox = form.querySelector('[data-notify-marketing-opt-in]');
    tags.push(marketingCheckbox && !marketingCheckbox.checked ? 'marketing_UNSUBSCRIBED' : 'marketing_SUBSCRIBED');

    tagsInput.value = tags.join(',');
  }

  function buildPhoneValue() {
    if (!form) return;
    var phoneValueInput = form.querySelector('[data-notify-phone-value]');
    var phoneInput = form.querySelector('[data-notify-phone-input]');
    var countrySelect = form.querySelector('[data-notify-country-code]');
    if (!phoneValueInput || !phoneInput || !countrySelect) return;

    var digits = phoneInput.value.replace(/[^0-9]/g, '');
    phoneValueInput.value = digits ? '+' + countrySelect.value + digits : '';
  }

  function setupMarketingToggle() {
    var checkbox = form && form.querySelector('[data-notify-marketing-opt-in]');
    if (checkbox) checkbox.addEventListener('change', updateTags);
  }

  function setupPhoneValidation() {
    var phoneInput = form && form.querySelector('[data-notify-phone-input]');
    if (!phoneInput) return;

    var allowedChars = /[0-9\s\-()]/;
    phoneInput.addEventListener('keypress', function (event) {
      if (!allowedChars.test(event.key) && !['Backspace', 'Delete', 'Tab', 'Enter'].includes(event.key)) {
        event.preventDefault();
      }
    });
    phoneInput.addEventListener('input', function (event) {
      var cleaned = event.target.value.replace(/[^0-9\s\-()]/g, '');
      if (event.target.value !== cleaned) event.target.value = cleaned;
    });
  }

  function setupClose() {
    var closeBtn = modal.querySelector('[data-notify-me-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeNotifyMeModal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeNotifyMeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('show')) closeNotifyMeModal();
    });
  }

  function checkForToast() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return;

    // Only after a Notify Me submission; any other customer form (e.g. the
    // footer newsletter) is left alone, URL included - theme.js reads the same
    // parameter to show that form's own success message.
    var submitted = false;
    try {
      submitted = sessionStorage.getItem(SUBMITTED_KEY) === '1';
      sessionStorage.removeItem(SUBMITTED_KEY);
    } catch (e) {}
    if (!submitted) return;

    params.delete('customer_posted');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, document.title, cleanUrl);

    // The header/footer market/locale switchers are separate server-rendered 'localization'
    // forms whose hidden "return_to" field bakes in whatever query string was present when the
    // page first loaded - including this same customer_posted=true. Cleaning the visible URL
    // above doesn't touch those already-rendered hidden fields, so switching markets right after
    // a submission would replay the stale param into the new page and show this toast again for
    // no real submission. Strip it from every such field instead of trusting the query param
    // alone - scoped to this one stale value, so it doesn't block a genuine toast for a later,
    // separate submission the way a blanket "shown once per tab" flag would.
    stripStaleParamFromReturnToInputs();

    var toast = document.querySelector('[data-notify-me-toast]');
    if (!toast) return;

    positionToast(toast);
    window.addEventListener('resize', function () {
      positionToast(toast);
    });

    toast.style.display = 'flex';
    setTimeout(function () {
      positionToast(toast);
      toast.classList.add('show');
    }, 100);
    setTimeout(function () {
      toast.classList.remove('show');
      setTimeout(function () {
        toast.style.display = 'none';
      }, 400);
    }, 3100);
  }

  function stripStaleParamFromReturnToInputs() {
    document.querySelectorAll('input[name="return_to"]').forEach(function (input) {
      if (!input.value || input.value.indexOf('customer_posted') === -1) return;

      var parts = input.value.split('?');
      var params = new URLSearchParams(parts[1] || '');
      params.delete('customer_posted');
      input.value = parts[0] + (params.toString() ? '?' + params.toString() : '');
    });
  }

  function positionToast(toast) {
    var gap = 16;
    var header = document.querySelector('[data-header-height]') || document.querySelector('.site-header');
    var anchor = header && (header.closest('.shopify-section') || header);

    if (!anchor) {
      toast.style.top = gap + 'px';
      return;
    }

    var bottom = anchor.getBoundingClientRect().bottom;
    var marginBottom = parseFloat(window.getComputedStyle(anchor).marginBottom) || 0;

    toast.style.top = Math.max(bottom + marginBottom + gap, gap) + 'px';
  }

  window.openNotifyMeModal = openNotifyMeModal;
  window.closeNotifyMeModal = closeNotifyMeModal;
})();
